<template>
  <div>
    <t-form labelWidth="100px">
      <!-- v-if="cptDataForm.dataSource == '4'" -->
     <CptData :data="attribute.cptTableData" :cptDataForm="cptDataForm" />
      <t-form-item label="图标">
        <div @click="showGallery" style="width: 168px; height: 160px">
          <t-image style="width: 100%; height: 100%"
                    :src=" attribute.bgUrl ? fileUrl + attribute.bgUrl:require('@/assets/custom/tuxiang.png')" fit="fill"/>
        </div>
      </t-form-item>
      <t-form-item label="图标宽度">
        <t-input-number size="small" v-model="attribute.iconWidth" :min="4" :max="600" :decimal-places="0"/>
      </t-form-item>
      <t-form-item label="图标高度">
        <t-input-number size="small" v-model="attribute.iconHeight" :min="4" :max="600" :decimal-places="0"/>
      </t-form-item>
      <t-form-item label="图标上边距">
        <t-input-number size="small" v-model="attribute.iconTop" :min="4" :max="600" :decimal-places="0"/>
      </t-form-item>
      <t-form-item label="图标下边距">
        <t-input-number size="small" v-model="attribute.iconBottom" :min="4" :max="600" :decimal-places="0"/>
      </t-form-item>

      <t-form-item label="标题">
        <t-input size="small" v-model="attribute.title" :maxcharacter="52"/>
      </t-form-item>
      <t-form-item label="标题宽度">
        <t-input-number size="small" v-model="attribute.titleWidth" :min="4" :max="600" :decimal-places="0"/>
      </t-form-item>
      <t-form-item label="标题上边距">
        <t-input-number size="small" v-model="attribute.paddingTop" :min="4" :max="600" :decimal-places="0"/>
      </t-form-item>
      <t-form-item label="标题左边距">
        <t-input-number size="small" v-model="attribute.titleLeft" :min="4" :max="600" :decimal-places="0"/>
      </t-form-item>
      <t-form-item label="总数">
        <t-input size="small" v-model="attribute.totalText" :maxcharacter="20"/>
      </t-form-item>
      <t-form-item label="总数上边距">
        <t-input-number size="small" v-model="attribute.totalTop" :min="4" :max="600" :decimal-places="0"/>
      </t-form-item>
      <t-form-item label="正常">
        <t-input size="small" v-model="attribute.normalText" :maxcharacter="20"/>
      </t-form-item>
      <t-form-item label="异常">
        <t-input size="small" v-model="attribute.errorText" :maxcharacter="20"/>
      </t-form-item>
      <t-form-item label="异常显示">
        <t-switch v-model="attribute.errorShow" :label="['显示', '不显示']" size="small"/>
      </t-form-item>
      <t-form-item label="进度显示">
        <t-switch v-model="attribute.progressShow" :label="['显示', '不显示']" size="small"/>
      </t-form-item>
      <t-form-item label="数值大小">
        <t-input-number size="small" v-model="attribute.numSize" :min="4" :max="600" :decimal-places="0"/>
      </t-form-item>
    </t-form>
    <gallery ref="gallery" @confirmCheck="confirmCheck"/>
  </div>
</template>

<script>
import Gallery from "@/components/designer/gallery";
import CptData from '@/components/element/options/comp/cpt-data'
import {fileUrl} from '/env'

export default {
  name: "cpt-icon-quota-option",
  props: { 
    attribute: Object,
    cptDataForm:Object,
    currentCpt:Object,
    },
  components: {Gallery,CptData},
  methods:{
    showGallery(){
      this.$refs.gallery.opened();
    },
    confirmCheck(fileUrl){
      this.attribute.bgUrl = fileUrl
    }
  },
  data(){
    return {
      fileUrl
    }
  }
}
</script>

<style scoped>
</style>